module.exports = __webpack_public_path__ + "static/img/207_TO8_2126_og.bf899e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/207_TO8_2126_og.jpg
// module id = 0MGU
// module chunks = 0